import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l14 0","key":"svg-0"}],["path",{"d":"M5 12l6 6","key":"svg-1"}],["path",{"d":"M5 12l6 -6","key":"svg-2"}]]

const IconArrowLeft = createReactComponent('outline', 'arrow-left', 'ArrowLeft', __iconNode);

export default IconArrowLeft;